import HelpTooltip from '@components/Tooltips/HelpTooltip';
import { FormControl, FormControlLabel, Switch } from '@mui/material';
import React, { useCallback } from 'react';

type Props = {
	label: string;
	setValue: (value: boolean) => void;
	value: boolean;
	// eslint-disable-next-line react/require-default-props
	helpTooltip?: string;
	// eslint-disable-next-line react/require-default-props
	disabled?: boolean;
	// eslint-disable-next-line react/require-default-props
	order?: number;
};

const SwitchControl: React.FC<Props> = ({
	value,
	setValue,
	label,
	helpTooltip,
	disabled,
	order
}: Props) => {
	const onChange = useCallback(
		(_: any, v: boolean) => {
			setValue(v);
		},
		[setValue]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset" sx={{ order }}>
			<FormControlLabel
				control={
					<Switch checked={value} onChange={onChange} disabled={disabled} />
				}
				label={
					<>
						{label}
						{helpTooltip && (
							<HelpTooltip
								title={helpTooltip}
								placement="top-end"
								sx={{ ml: 1 }}
							/>
						)}
					</>
				}
			/>
		</FormControl>
	);
};

const MemoSwitchControl = React.memo(SwitchControl);

export { MemoSwitchControl as SwitchControl };
